var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.663 4.45l5.451 5.451L8.316 23.7l-5.448-5.451L16.663 4.45zm9.588-1.314L23.82.705c-.94-.94-2.465-.94-3.408 0l-2.329 2.328 5.451 5.451 2.717-2.716c.728-.729.728-1.904 0-2.632zM.015 25.91c-.099.446.304.846.75.738l6.075-1.473-5.448-5.451L.015 25.91z",
    transform: "translate(-855.000000, -1745.000000) translate(96.000000, 1479.000000) translate(213.000000, 138.000000) translate(522.000000, 38.000000) translate(0.000000, 14.000000) translate(0.000000, 64.000000) translate(24.000000, 12.000000) translate(2.666667, 2.666667)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.88fa37c7.svg";
export { ForwardRef as ReactComponent };